import { piqureWrapper } from 'piqure';

const { provideLazy, inject } = piqureWrapper(globalThis, 'piqure.rules-management');

export { provideLazy, inject };
